import React from "react";

const colors = [
  "Black",
  "Blue",
  "Brown",
  "Copper",
  "Gold",
  "Gray",
  "Green",
  "Ivory",
  "Orange",
  "Pink",
  "Purple",
  "Red",
  "Silver",
  "Taupe",
  "Turquoise",
  "White",
  "Yellow",
];

export default function ColorWheel({ onChange }) {
  return (
    <>
      {colors.map((c, index) => (
        <div
          id={c.toLowerCase()}
          key={c + index}
          onClick={() => {
            onChange("color", c);
            console.log("clicking");
          }}
          className="circle"
        ></div>
      ))}
    </>
  );
}
